export const TOGGLE_MINIMAP = 'TOGGLE_MINIMAP'
export const toggleMinimap = () => ({ type: TOGGLE_MINIMAP })

export const MINIMAP_INTERACTION = 'MINIMAP_INTERACTION'
export const minimapInteraction = () => ({ type: MINIMAP_INTERACTION })
